<div class="panel">
  <div class="tab-row">
    @for (tab of tabs; track tab) {
      <div class="tab" [class.selected]="selectedTab === tab" (click)="selectTab(tab)">
        {{tab}}
      </div>
    }

    <div class="controls">
      @if (selectedRefreshable) {
        <button (click)="refresh()" type="button" class="control-button">
          <img alt="" src="/assets/default/refresh.svg">
        </button>
      }
      @if (selectedCreatable) {
        <button (click)="add()" type="button" class="control-button">
          <img alt="" src="/assets/default/add.svg">
        </button>
      }
    </div>
  </div>
  <div #content class="content">
    <ng-content></ng-content>
  </div>
</div>
